import axios from 'axios';
import { readAssumedUser, ASSUME_USER_HEADER } from './assumeUser';

const apiBaseUrl = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const hasHeader = (headers, name) => Boolean(headers) && (typeof headers.has === 'function'
  ? headers.has(name)
  : Object.keys(headers).some((key) => key.toLowerCase() === name.toLowerCase()));

// While the Admin is viewing the app as a user, every request says so and the server answers as that person. A request
// that sets the header itself (empty, to be the real account) is left alone.
api.interceptors.request.use((config) => {
  const assumed = readAssumedUser();
  if (assumed && !hasHeader(config.headers, ASSUME_USER_HEADER)) {
    if (typeof config.headers.set === 'function') config.headers.set(ASSUME_USER_HEADER, String(assumed.id));
    else config.headers[ASSUME_USER_HEADER] = String(assumed.id);
  }
  return config;
});

// When server returns 503 with maintenance flag (e.g. during deploy), show "Server is being restarted" overlay
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 503 && err.response?.data?.maintenance) {
      window.dispatchEvent(new CustomEvent('server-maintenance', { detail: err.response.data }));
    }
    return Promise.reject(err);
  }
);

export default api;
